import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import type { Endpoint } from '@/services/endpoints'
import BaseWrapper from '@/data/models/wrappers/BaseWrapper'

@RepoSettings<Endpoint>({
  model: BaseWrapper,
})
@injectable()
@injectFromBase()
export default class BaseWrapperRepository extends OrmApiRepository<BaseWrapper> {}
